import { Form, Button, Dimmer, Loader } from "semantic-ui-react";
import useApiCmp from "../../hooks/useApiCmp";
import useForm from "../../hooks/useForm";
import MessageErrorsValidation from "../../components/MessageErrorsValidation";
import moment from "moment/moment";
import { useState } from "react";
import MessageApiErrors from "../../components/MessageApiErrors";
import AjustaNomeModal from "./components/AjustaNomeModal";
import { instanceAxiosApiFiliado } from "../../dataProviders";
import useTempStorage, { KEY_COOKIE_HASH_PEDIDO } from "../../hooks/useTempStorage";

function StepCaracteristicas({
  dadosPedido,
  setDadosPedido,
  nextStep,
  previousStep,
}) {
  const { data: identidadeGenero } = useApiCmp("/identidade-genero");
  const { data: orientacaoSexual } = useApiCmp("/orientacao-sexual");
  const { data: etnias } = useApiCmp("/etnia");
  const [isLoading, setIsLoading] = useState(false);
  const [erro, setErro] = useState(null);
  const {updateCookie: setHashCookie} = useTempStorage(KEY_COOKIE_HASH_PEDIDO);

  const [abreModalNome, setAbreModalNome] = useState(false);

  const getOptionsIdentidadeGenero = () => {
    let options = [];

    if (!identidadeGenero._embedded) return [];

    options = identidadeGenero._embedded["identidade-genero"].map((s) => ({
      key: s.codIdentidadeGenero,
      value: s.codIdentidadeGenero,
      text: s.nomeIdentidadeGenero,
    }));

    options.unshift({key: -1});

    return options;
  };

  const getOptionsOrientacaoSexual = () => {
    let options = [];

    if (!orientacaoSexual._embedded) return [];

    options = orientacaoSexual._embedded["orientacao-sexual"].map((s) => ({
      key: s.codOrientacaoSexual,
      value: s.codOrientacaoSexual,
      text: s.nomeOrientacaoSexual,
    }));

    options.unshift({key: -1});

    return options;
  };

  const getOptionsEtnia = () => {
    let options = [];

    if (!etnias._embedded) return [];

    options = etnias._embedded["etnia"].map((s) => ({
      key: s.codEtnia,
      value: s.codEtnia,
      text: s.nomeEtnia,
    }));

    options.unshift({key: -1});

    return options;
  };

  const nextWithValidation = () => {
    setIsLoading(true);
    instanceAxiosApiFiliado
      .post("/public/incluir-pedido", {
        ...dadosPedido,
        nomeSocial: data.nomeSocial,
        nomeRegistro: data.nomeRegistro,
        outraOrientacaoSexual: data.outraOrientacaoSexual,
        identidadeGenero: data.identidadeGenero,
        orientacaoSexual: data.orientacaoSexual,
        etnia: data.etnia,
        dataNasc: data.dataNasc,
        zonal: data.zonal?.codigoZonal,
      })
      .then((res) => {
        setDadosPedido({
          ...dadosPedido,
          identidadeGenero: data.identidadeGenero,
          orientacaoSexual: data.orientacaoSexual,
          etnia: data.etnia,
          dataNasc: data.dataNasc,
        });
        setHashCookie(res.data.hash);

        nextStep();
      })
      .catch((e) => setErro(e))
      .then(() => setIsLoading(false));
  };

  const validations = {
    identidadeGenero: {
      required: {
        value: true,
        message: "Informe sua identidade de gênero",
      },
    },
    orientacaoSexual: {},
    outraOrientacaoSexual: {},
    etnia: {
      required: {
        value: true,
        message: "Informe sua etnia",
      },
    },
    dataNasc: {
      required: {
        value: true,
        message: "Informe sua data de nascimento",
      },
      custom: {
        isValid: (value) => moment().diff(value, "years") >= 16 && moment().diff(value, "years") <= 120,
        message: "Digite uma data válida. Você precisa ter pelo menos 16 anos",
      },
    },
  };

  const changeIdentidadeGeneroHandle = (e, data) => {
    handleChange("identidadeGenero", data.value);

    if ([3, 4, 5, 6].includes(data.value)) {
      setAbreModalNome(true);
    }
  };

  const {
    data,
    handleChange,
    handleChangeObject,
    handleSubmit,
    handleBlur,
    errors,
  } = useForm(validations, dadosPedido, nextWithValidation);

  return (
    <>
      {erro && <MessageApiErrors erro={erro} />}
      <Dimmer active={isLoading} inverted>
        <Loader >Aguarde ...</Loader>
      </Dimmer>
      <Form.Group widths="equal">
        <Form.Select
          fluid
          required
          label="Identidade de gênero"
          name="identidadeGenero"
          id="identidadeGenero"
          value={data.identidadeGenero}
          options={getOptionsIdentidadeGenero()}
          onBlur={handleBlur}
          error={!!errors.identidadeGenero}
          onChange={changeIdentidadeGeneroHandle}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Select
          label="Quer informar sua orientação sexual?"
          name="orientacaoSexual"
          id="orientacaoSexual"
          value={data.orientacaoSexual}
          options={getOptionsOrientacaoSexual()}
          onBlur={handleBlur}
          error={!!errors.orientacaoSexual}
          onChange={(e, data) => handleChange("orientacaoSexual", data.value)}
        />
        {data.orientacaoSexual === 9 ? <Form.Input 
          label="Informe sua orientação sexual"
          required
          name="outraOrientacaoSexual"
          id="outraOrientacaoSexual"
          value={data.outraOrientacaoSexual}
          onBlur={handleBlur}
          error={!!errors.outraOrientacaoSexual}
          onChange={(e, data) => handleChange("outraOrientacaoSexual", data.value)} /> : null}
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Select
          required
          label="Etnia"
          name="etnia"
          id="etnia"
          value={data.etnia}
          options={getOptionsEtnia()}
          onBlur={handleBlur}
          error={!!errors.etnia}
          onChange={(e, data) => handleChange("etnia", data.value)}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Input
          required
          name="dataNasc"
          label="Data de nascimento"
          type="date"
          value={data.dataNasc}
          onBlur={handleBlur}
          error={!!errors.dataNasc}
          onChange={(e, data) => handleChange("dataNasc", data.value)}
        />
      </Form.Group>
      <MessageErrorsValidation errors={errors} />
      <Button className="buttonAcaoMetade" onClick={previousStep} secondary>
        Voltar
      </Button>
      <Button className="buttonAcaoMetade" onClick={handleSubmit} primary>
        Continuar
      </Button>
      <AjustaNomeModal
        setIsOpen={setAbreModalNome}
        isOpen={abreModalNome}
        onChangeNomes={(nomes) => handleChangeObject({ ...data, ...nomes })}
        nomeInicial={data.nomeSocial}
      />
    </>
  );
}

export default StepCaracteristicas;
